import { VbzButton } from "@smiles/voebiz-ui-kit";
import React from "react";
import { useTranslation } from "react-i18next";

import { Bag, MobileBag } from "../../assets/index";
import { TYPE_COMPONENT } from "../../constants/index";

export interface IErrorEmpty {
  typeComponent: string;
}

const InfoError: React.FC<IErrorEmpty> = ({ typeComponent }) => {
  const { t } = useTranslation("errorEmpty");

  return (
    <>
      <div className="error-info-empty-flight">
        <div className="label-error-empty">
          <div className="icon">
            <img className="baggage" src={Bag} alt={t("alt")} />
            <img className="baggage-mobile" src={MobileBag} alt={t("alt")} />
          </div>
          <div className="info">
            <h1 className="title">{t("title")}</h1>
            <h2 className="description">
              {typeComponent !== TYPE_COMPONENT ? t("description") : t("description_simple")}
            </h2>

            <div className="label-error-empty__btn">
              <VbzButton
                className="with-border"
                type="button"
                text={t("btn_rescue_points")}
                color="pills"
                onClick={() => {
                  window.location.href = "/home";
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfoError;
